import { useEffect, useState } from "react";
import axios from "../../utils/axiosInstance";

import FaultSetpointsC5 from "./FaultSetpointsC5";
import FaultSetpointsWP from "./FaultSetpointsWP";
export default function FaultSetpoints({ selectedDevice }) {
  console.log("Rendering FaultSetpoints for device:", selectedDevice);
  const [type, setType] = useState("");
  const [loading, setLoading] = useState(true);

  const fetchData = async () => {
    try {
      setLoading(true);

      const engResp = await axios.get(
        `${process.env.REACT_APP_API_GATEAWAY}/iot/engine-data/${selectedDevice.device.id}`,
      );

      setType(engResp.data.type || "");
      //console.log("Engine type:", engResp.data.type);
    } catch (error) {
      console.error("Error fetching engine type:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!selectedDevice?.device?.id) return;
    fetchData();
  }, [selectedDevice?.device?.id]);

  if (loading) return null; // or spinner

  if (type === "C5" || type === "C5E") {
    return <FaultSetpointsC5 selectedDevice={selectedDevice} />;
  }

  return <FaultSetpointsWP selectedDevice={selectedDevice} />;
}
